




























































import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
  private isShowSnackbar = false;

  private snackbarText = '';

  private showSnackbar(text: string) {
    this.snackbarText = text;
    this.isShowSnackbar = true;
  }

  private onClickToCreate() {
    this.$router.push('/');
  }

  private onClickToAudit() {
    this.$router.push('/audit');
  }

  private onClickToHistory() {
    this.$router.push('/history');
  }
}
